import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { intialLoading, setIndex } from "../../store/screentransistion/actions";
import { saveUserDetails } from "../../store/trackinguser/actions";
import Layout from "../common/layoutred";

import { fetchShuffle } from "../../store/shuffledata/operations";
import { Alert } from "@material-ui/lab";
import { isAndroid } from "react-device-detect";
import fullScreen from "../../utils/fullScreen";
import { connect } from "react-redux";
import {
	Button,
	FormControl,
	MenuItem,
	Select,
	TextField,
} from "@material-ui/core";
import {
	toggleMusic,
	toggleVoiceOver,
} from "../../store/screentransistion/actions";
import { headers } from "../../utils/authAxios";

import "./style.scss";
import { BROWSER_DATA } from "../../store/types";

window.gtag("event", "REGISTRATION", {
	event_category: "REGISTRATION",
	event_label: "REGISTRATION",
});

const Registration = ({
	// fetchShuffle,
	shuffleData,
	progress,
	languages,
	zones,
	saveUserDetails,
	audio,
	intialLoading,
	setIndex,
	gameSessionId,
	language,
	toggleMusic,
	toggleVoiceOver,
	tokenValidation,
}) => {
	const dispatch = useDispatch();

	const [india] = zones;
	// const [english] = languages;
	const lang = languages.find((l) => l.value === "en");
	// const english = languages.find((l) => l.value == "km");

	const [data, setData] = useState({
		zone: india._id,
		lang: lang.value,
		number: "",
		name: "",
	});

	const activate = fullScreen();

	const [error, setError] = useState(false);
	const [msg, setMsg] = useState("Please enter valid details");

	const handleChange = (event) => {
		const { name, value } = event.target;
		
		// Validation for mobile number
		if (name === 'number') {
			const rExp = /^[0-9\b]+$/;
			if (rExp.test(value)) {
				if (value.length <= 10) {
					setData({ ...data, [name]: value });
					setError(false);
				} else {
					setError(true);
					setMsg('Maximum 10 numbers allowed');
					return;
				}
			} else if (value === '') {
				setData({ ...data, [name]: '' });
				setError(false);
			} else {
				setError(true);
				setMsg('Please enter a valid number');
				return;
			}
		} else {
			setData({ ...data, [name]: value });
		}
		
		dispatch({
			type: BROWSER_DATA,
			payLoad: { ...data, [name]: value },
		});
	};

	// useEffect(()=>{
	//   saveAnalytics({screenID:"USER_AT_REGISTRATION"}, () => {}, () => {});
	// },[])

	const register = (event) => {
		event.preventDefault();
		
		// Validate mobile number
		if (data.number.length !== 10) {
			setError(true);
			setMsg('Please enter a valid 10-digit mobile number');
			return;
		}
		
		// Validate name
		if (!data.name || data.name.trim() === '') {
			setError(true);
			setMsg('Please enter your name');
			return;
		}
		
		if (data.lang && data.zone && data.number && data.name) {
			// Set mobile number as user-token in headers
			headers["user-token"] = data.number;
			
			// saveAnalytics(
			// 	{ screenID: "USER_AT_REGISTRATION" },
			// 	() => {},
			// 	() => {}
			// );
			if (isAndroid) {
				activate();
			}
			intialLoading();
		} else {
			setError(true);
			setMsg("All fields are required");
		}
	};

	return (
		<>
			<Layout>
				<div className="registration__container">
					<form onSubmit={register}
					style={{
						margin: '2rem'
					}}
					>
						<div className="form_control company-name-container">
							<span className="company-name">
								Personality Mirror
							</span>
						</div>
						
						<FormControl
							variant="outlined"
							size="small"
							style={{
								width: "100%",
								marginTop: "20px",
								backgroundColor: "white",
							}}>
							<Select
								id="simple-select"
								name="lang"
								value={data.lang}
								onChange={handleChange}
								style={{
									fontSize: 12,
								}}>
								{languages
									? languages.map((lan) => (
											<MenuItem key={lan.value} value={lan.value}>
												{lan.language}
											</MenuItem>
									  ))
									: null}
							</Select>
						</FormControl>

						<TextField
							variant="outlined"
							size="small"
							name="name"
							label="Enter Your Name"
							value={data.name}
							onChange={handleChange}
							style={{
								width: "100%",
								marginTop: "20px",
								backgroundColor: "white",
								fontSize: 18,
							}}
							required
						/>

						<TextField
							variant="outlined"
							size="small"
							name="number"
							label="Enter Mobile Number"
							type="number"
							value={data.number}
							onChange={handleChange}
							style={{
								width: "100%",
								marginTop: "20px",
								backgroundColor: "white",
								fontSize: 18,
							}}
							required
						/>

						<div className="_button_container">
							<Button
								type="submit"
								variant="contained"
								className="_button"
								style={{ width: "100%" }}>
								START
							</Button>
						</div>

						<div className="form__control error__msg">
							{error ? (
								<Alert severity="error">
									<h3>{msg}</h3>
								</Alert>
							) : null}
						</div>
					</form>
				</div>
			</Layout>
		</>
	);
};

const mapStateToProps = (state) => {
	return {
		shuffleData: state.shuffleData,
		progress: state.progress,
		languages: state.intialize.languages,
		zones: state.intialize.zones,
		audio: state.shuffleData,
		language: state.trackingUser.userDeatils,
		tokenValidation: state.intialize.tokenValidation,
	};
};

const mapDispathToProps = (dispatch) => {
	return {
		fetchShuffle: (language, success, failure) =>
			dispatch(fetchShuffle(language, success, failure)),
		saveUserDetails: (details) => dispatch(saveUserDetails(details)),
		intialLoading: () => dispatch(intialLoading()),
		setIndex: (index) => dispatch(setIndex(index)),
		toggleMusic: (toggle) => dispatch(toggleMusic(toggle)),
		toggleVoiceOver: (toggle) => dispatch(toggleVoiceOver(toggle)),
	};
};

export default connect(mapStateToProps, mapDispathToProps)(Registration);
